type Fonts = {
  roboto: string;
  poppins: string;
};

export const fonts: Fonts = {
  roboto: "'Roboto', sans-serif",
  poppins: "'Poppins', sans-serif",
};
